import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getLocalizedPartName } from '../utils/voicePartNames';

const SelectMePartDialog = ({ isOpen, parts, onSelect, onClose }) => {
  const { t } = useLanguage();

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000
      }}
    >
      <div
        className="modal-dialog"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#1f2937',
          border: '1px solid #374151',
          borderRadius: '12px',
          width: '90%',
          maxWidth: '420px',
          overflow: 'hidden',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
        }}
      >
        {/* Header */}
        <div style={{
          background: '#3b82f6',
          color: '#f9fafb',
          padding: '16px 24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #374151'
        }}>
          <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
            🎯 {t('mePartDialog.title')}
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#e5e7eb',
              fontSize: '24px',
              cursor: 'pointer',
              width: '32px',
              height: '32px',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: '24px' }}>
          <p style={{
            color: '#e5e7eb',
            fontSize: '15px',
            lineHeight: '1.5',
            marginTop: 0,
            marginBottom: '20px'
          }}>
            {t('mePartDialog.message')}
          </p>

          {/* Part Buttons */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            marginBottom: '20px'
          }}>
            {parts.map(part => {
              const localizedName = getLocalizedPartName(part.name, t);
              return (
                <button
                  key={part.id}
                  onClick={() => onSelect(part.id)}
                  style={{
                    background: '#374151',
                    color: '#f9fafb',
                    border: '1px solid #4b5563',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    fontSize: '15px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    textAlign: 'left',
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '8px'
                  }}
                >
                  <span>{localizedName}</span>
                  {localizedName !== part.name && (
                    <span style={{ color: '#9ca3af', fontSize: '13px', fontWeight: 'normal' }}>
                      ({part.name})
                    </span>
                  )}
                </button>
              );
            })}
          </div>

          {/* Skip */}
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button
              onClick={onClose}
              style={{
                background: 'transparent',
                color: '#9ca3af',
                border: '1px solid #4b5563',
                padding: '8px 16px',
                borderRadius: '6px',
                fontSize: '13px',
                cursor: 'pointer'
              }}
            >
              {t('mePartDialog.skip')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectMePartDialog;
